//frontend/src/App.js
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Home from './pages/Home';
import SelectService from './pages/SelectService';
import SelectSpecialist from './pages/SelectSpecialist';
import SelectDateTime from './pages/SelectDateTime';
import Confirmation from './pages/Confirmation';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Auth from './pages/Auth';
import BookingSteps from './components/BookingSteps';
import Notifications from './components/Notifications';
import { LanguageSwitcher } from './components/LanguageSwitcher';

import { useEffect } from 'react';
import { updateFavicon } from './utils/favicon';
import axiosInstance from './utils/axios';

function App() {
   const { t } = useTranslation();
   const location = useLocation();
   const isBookingRoute = location.pathname.includes('select-') || location.pathname.includes('confirmation');

   useEffect(() => {
    const fetchSettings = async () => {
        try {
            const response = await axiosInstance.get('/settings');
            if (response.data?.logoImage) {
                updateFavicon(response.data.logoImage);
            }
            if (response.data?.headerTitle) {
                document.title = response.data.headerTitle;
            }
        } catch (error) {
            console.error('Error fetching settings:', error);
        }
    };
    
    fetchSettings();
}, []);

   return (
       <>
           <AppBar position="static">
               <Toolbar>
                   <Typography variant="h6" sx={{ flexGrow: 1 }}>
                       {/* Можно добавить перевод для названия, если нужно */}
                       CRM
                   </Typography>
                   <LanguageSwitcher />
               </Toolbar>
           </AppBar>

           {isBookingRoute && <BookingSteps />}
           <Notifications />
           <Routes>
               <Route path="/" element={<Home />} />
               <Route path="/select-service" element={<SelectService />} />
               <Route path="/select-specialist" element={<SelectSpecialist />} />
               <Route path="/select-datetime" element={<SelectDateTime />} />
               <Route path="/confirmation" element={<Confirmation />} />
               <Route path="/auth" element={<Auth />} />
               <Route path="/login" element={<Login />} />
               <Route path="/register" element={<Register />} />
               <Route path="/dashboard" element={<Dashboard />} />
           </Routes>
       </>
   );
}

export default App;